import React, { FC, ReactNode } from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface IEmptyState {
  title: string;
  subtitle?: ReactNode;
}

const TableEmptyState: FC<IEmptyState> = ({ title, subtitle, ...rest }) => {
  return (
    <Wrapper {...rest}>
      <Title variant="h2" component="h2" align="center">
        {title}
      </Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Wrapper>
  );
};

export default TableEmptyState;

const Wrapper = styled('div')`
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => alpha(theme.palette.common.white, 0.31)};
`;
const Title = styled(Typography)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 48px;
  }
` as typeof Typography;
const Subtitle = styled('p')`
  text-align: center;
`;
